import { Skeleton } from "../../components/Skeleton.js";
import { ChartPanel } from "../../components/ui/charts/ChartPanel.js";

/**
 * Stand-in for the Summary strip while the stats request is in flight. It holds
 * the same shapes and heights as the real thing, so nothing jumps when the data
 * lands and the charts animate up from zero.
 *
 * Deliberately free of Recharts, so it can render from the entry chunk while the
 * chart bundle is still downloading.
 */
export function EmployeeSummarySkeleton({ chips = true }: { chips?: boolean }) {
  return (
    <>
      {chips && (
        <div className="mb-4 flex flex-wrap items-center gap-2">
          {[44, 74, 104, 86, 110, 102].map((w, i) => (
            <Skeleton key={i} width={w} height={32} borderRadius="var(--radius-md)" />
          ))}
        </div>
      )}

      <div className="grid gap-3 lg:grid-cols-3">
        <ChartPanel title="By department" hint="Share of headcount">
          <div className="flex items-center gap-4">
            <Skeleton width={148} height={148} borderRadius="50%" />
            <div className="flex min-w-0 flex-1 flex-col gap-2">
              {[0, 1, 2, 3, 4].map(i => <Skeleton key={i} height={11} />)}
            </div>
          </div>
        </ChartPanel>

        <ChartPanel title="By office" hint="Top offices by headcount">
          <div className="flex flex-col gap-3 py-1">
            {["70%", "88%", "54%", "40%", "30%"].map((w, i) => (
              <div key={i} className="flex items-center gap-2">
                <Skeleton width={84} height={11} />
                <Skeleton width={w} height={12} />
              </div>
            ))}
          </div>
        </ChartPanel>

        <ChartPanel title="Headcount mix" hint="Status composition">
          <div className="flex flex-col gap-3">
            <Skeleton height={18} />
            <div className="flex flex-wrap gap-x-4 gap-y-2">
              {[70, 88, 64, 92].map((w, i) => <Skeleton key={i} width={w} height={11} />)}
            </div>
          </div>
        </ChartPanel>
      </div>
    </>
  );
}
